// src/mocks/handlers/creditNotes.handlers.js
import * as data from '../data/creditNotes.demo';

export const handle = async (config) => {
    if (config.method === 'post') return { success: true, data: {} };
    if (/\/credit-notes\/\d+/.test(config.url)) return data.creditNoteDetail;
    return data.creditNoteList;
};

export const getCreditableItems = async () => data.creditableItems;
export const canCredit          = async () => data.canCreditResult;
export const getByInvoice       = async () => data.creditNoteList;
export const retry              = async () => ({ success: true });
export const getPdf             = async () => ({ url: '' });
